import {
  Users,
  Layers,
  Target,
  Handshake,
  Building2,
  BarChart3,
  Shield,
  Radio
} from "lucide-react";

export const whyUsSections = [
  {
    id: "extension",
    icon: Users,
    number: "01",
    title: "A True Extension of Your Internal Communications Team",
    description: "Rather than operating as an external supplier, ICA functions as a fully embedded internal communications department, supporting organisations with strategy, content creation and delivery across all employee communication channels.",
    heading: "Why this matters vs traditional agencies",
    points: [
      "Reduces pressure on internal teams",
      "One partner managing all communications activity",
      "Consistent organisational messaging",
      "Faster delivery across departments"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/t2ce0v2v_combined_vertical.jpg",
    imageContain: true
  },
  {
    id: "in-house",
    icon: Layers,
    number: "02",
    title: "All Communications Expertise Delivered In-House",
    description: "All creative, strategic and production work is delivered by ICA's own specialists, including:",
    capabilities: [
      "Internal communications strategy",
      "Video and visual content production",
      "Design and digital communications",
      "Campaign planning",
      "Employee engagement content"
    ],
    heading: "Competitive advantage",
    points: [
      "Greater consistency and quality control",
      "Faster turnaround times",
      "Direct collaboration with the delivery team",
      "No reliance on third-party suppliers"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/61cx7cyf_low%20res%20DSC_0027.jpg"
  },
  {
    id: "tailored",
    icon: Target,
    number: "03",
    title: "Tailored Communications \u2014 Not Off-the-Shelf Solutions",
    description: "ICA develops bespoke internal communications strategies aligned to organisational culture, workforce structure and leadership objectives.",
    capabilities: [
      "Employee audiences",
      "Business priorities",
      "Change or transformation goals",
      "Engagement challenges"
    ],
    heading: "Why organisations value this",
    points: [
      "Communications feel relevant and authentic",
      "Stronger employee engagement",
      "Messaging aligned to real operational needs"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/9byspwse_IMG_0038%20%281%29.jpg"
  },
  {
    id: "partnership",
    icon: Handshake,
    number: "04",
    title: "Ongoing Collaboration and Strategic Partnership",
    description: "Clients work closely with the communications team through regular planning and review sessions focused on priorities, performance and upcoming activity.",
    heading: "Difference from typical agencies",
    points: [
      "Continuous support rather than ad-hoc projects",
      "Transparent collaboration",
      "Ability to adapt messaging quickly during change or crisis"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/kfsrtjoh_IMG_2626.jpg"
  },
  {
    id: "proven",
    icon: Building2,
    number: "05",
    title: "Proven Delivery Across Complex Organisations",
    description: "ICA brings extensive experience delivering large-scale communication programmes across public and private sector organisations.",
    heading: "This includes supporting",
    capabilities: [
      "Workforce engagement initiatives",
      "Organisational change communications",
      "Leadership messaging",
      "Multi-channel employee campaigns"
    ],
    points: [
      "Confidence that communications are delivered effectively across diverse teams and stakeholders"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/g1be1bfw_A001_03262248_C154.braw.22_49_39_10.Still001.jpg"
  },
  {
    id: "outcomes",
    icon: BarChart3,
    number: "06",
    title: "Outcomes-Focused Approach",
    description: "This ensures communications activity delivers measurable organisational impact rather than simply producing content.",
    heading: "Success is measured against",
    points: [
      "Employee engagement levels",
      "Message reach and understanding",
      "Behavioural or cultural change",
      "Adoption of organisational initiatives"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/gix2xvzv_dave%20cropped%202.jpg"
  },
  {
    id: "flexible",
    icon: Shield,
    number: "07",
    title: "Flexible and Low-Risk Engagement Model",
    description: "ICA offers a flexible partnership model designed to complement internal teams, including:",
    capabilities: [
      "No restrictive long-term contracts",
      "Scalable support depending on organisational need",
      "Ability to access full communications support or individual services"
    ],
    points: [
      "Organisations gain specialist capability without increasing permanent headcount"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/wzoc2x89_IMG_0080%20%281%29.jpg"
  },
  {
    id: "frontline",
    icon: Radio,
    number: "08",
    title: "Experience Supporting Operational and Frontline Workforces",
    description: "ICA understands the challenges of communicating across dispersed, operational or non-desk-based teams and designs communications accordingly.",
    heading: "This includes",
    points: [
      "Accessible formats",
      "Multi-channel delivery",
      "Clear, practical messaging for frontline employees"
    ],
    image: "https://customer-assets.emergentagent.com/job_2f219309-49d2-4096-9b1f-9aa2825973b1/artifacts/1uxa21cb_IMG_2367%20%281%29.JPG"
  }
];
